module.exports = __webpack_public_path__ + "img/wallet.4aaaa3ae.svg";